import { gql } from '@apollo/client';

export const DeleteCountry = gql`
mutation DeleteCountry($deleteCountryId: ID!) {
  deleteCountry(id: $deleteCountryId) {
    status
  }
}
`;